export default {
    baseURL: process.env.VUE_APP_API_URL.concat('v1/'),
    template: [
        'SUGGESTION_TEMPLATE',
        data => ({
            suggestion: data.suggestion,
            type: data.type,
        }),
    ],

    GET: {},
};
